import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
import { ServerRootService } from '@se/se.ui.html5';

import { BusinessUnit, Examination, Provenance } from 'estensa-module';

export const ESTENSA_MODULE_RADIOLOGY_COMMON_SERVICE = new InjectionToken('estensa.module.radiology.common.service');

export interface Html5CollectionMethods {
    GetAllProvenances: Provenance[];
    GetBusinessUnits: BusinessUnit[];
    GetProvenances: Provenance[];
}

/**
 * Wrapper per le chiamate alle collection - potrebbero essere in cache nel vecchio client?
 */
export type IRadiologyCommonServiceNg1 = {
    [method in keyof Html5CollectionMethods as Uncapitalize<method>]: () => {
        $promise: Promise<Html5CollectionMethods[method]>;
    };
};

export class NullRadiologyCommonService implements IRadiologyCommonServiceNg1 {
    getAllProvenances = () => ({ $promise: Promise.resolve([]) });
    getBusinessUnits = () => ({ $promise: Promise.resolve([]) });
    getProvenances = () => ({ $promise: Promise.resolve([]) });
}

/**
 * Per le chiamate semplici, invece di creare un wrapper, le eseguiamo direttamente da angular.
 */
@Injectable({
    providedIn: 'root',
})
export class RadiologyCommonService {
    constructor(
        private http: HttpClient,
        private serverRoot: ServerRootService,
    ) {}

    getFullExamination(examinationId: string) {
        return this.http.get<Examination>(`${this.serverRoot.getServerRoot()}/RadiologyCommon/GetFullExamination`, {
            ...this.serverRoot.buildOptions(),
            params: { examinationId },
        });
    }
}
